import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation DeleteMagnetTimeout($id: ID!) {
  deleteMagnetTimeout(id: $id) {
    id
  }
}`;

function deleteMagnet(id) {
  return apollo.client.mutate({
    mutation,
    variables: {
      id,
    },
  }).then((res) => res.data.deleteMagnetTimeout);
}

export default deleteMagnet;
